<template>
  <div id="cheque">
    <loading v-if="loadingRender"></loading>
    <panel
      Title="چک‌های واگذاری‌شده"
      Des="از طریق این فرم می‌توانید چک‌های واگذاری‌شده خود را مشاهده نمایید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-money-check"></i>
          چک‌های واگذاری‌شده
        </h6>
      </template>
      <template slot="content">
        <div class="cheque-report-filters" id="Date">
          <p class="cheque-report-hint">
            پارامترهای خود را انتخاب کنید و سپس
            <strong>جستجو</strong>
            را بزنید.
          </p>
          <div class="cheque-report-filters__row">
            <div class="cheque-report-field cheque-report-field--date">
              <label class="cheque-report-label">تاریخ چک از</label>
              <date-picker :editable="true" :auto-submit="true" :max="TarikhTa" color="#287db4" v-model="TarikhAz"></date-picker>
              <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
            </div>
            <div class="cheque-report-field cheque-report-field--date">
              <label class="cheque-report-label">تاریخ چک تا</label>
              <date-picker :editable="true" :auto-submit="true" :min="TarikhAz" color="#287db4" v-model="TarikhTa"></date-picker>
              <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
            </div>
            <div class="cheque-report-field">
              <label class="cheque-report-label" for="ShomareChek">شماره چک</label>
              <input
                id="ShomareChek"
                v-model="ShomareChek"
                type="text"
                dir="ltr"
                inputmode="numeric"
                autocomplete="off"
                class="form-control"
                @keypress="$ValidNumber($event, 20)"
              />
            </div>
            <div class="cheque-report-field">
              <label class="cheque-report-label" for="cmbTaahodat">انتخاب حساب</label>
              <select name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer" v-model="Resultcmb">
                <option v-if="IsLoad == false" value="-2">|| در حال بارگذاری ، منتظر بمانید ... ||</option>
                <option selected value="-1">-- انتخاب حساب --</option>
                <option v-for="item in ListModel" :key="item.id" :value="item.id">
                  <span>{{ item.vcodeDesNo }} </span><span>{{ item.nameFamily }} </span>
                </option>
              </select>
            </div>
            <div class="cheque-report-field">
              <label class="cheque-report-label" for="cmbGrp8">انتخاب وضعیت چک</label>
              <select name="cmbGrp8" id="cmbGrp8" class="form-control Pointer" v-model="ResultcmbGrp8">
                <option v-if="IsLoad == false" value="-2">|| در حال بارگذاری ، منتظر بمانید ... ||</option>
                <option selected value="-1">-- انتخاب وضعیت --</option>
                <option v-for="item in ListModelcmb" :key="item.id" :value="item.id">
                  <span>{{ item.name }}</span>
                </option>
              </select>
            </div>
            <div class="cheque-report-field cheque-report-field--action">
              <span class="cheque-report-label cheque-report-label--spacer" aria-hidden="true">&nbsp;</span>
              <button
                type="button"
                class="btn btn-success cheque-report-search-btn"
                @click="
                  GetCheque();
                  $ResetTimer();
                "
              >
                <i class="fa fa-search ml-1" aria-hidden="true"></i>
                جستجو
              </button>
            </div>
          </div>
          <ExcelExport :data="exceltable" worksheet-name="Sheet1" @success="handleExcelSuccess" @error="handleExcelError" class="d-none">
            <button type="button" class="d-none" tabindex="-1">
              <i class="d-none" id="DownloadExcel"></i>
            </button>
          </ExcelExport>
        </div>

        <div class="cheque-report-cards" dir="rtl">
          <p v-if="!rows.length" class="cheque-report-cards__empty">اطلاعاتی یافت نشد</p>
          <template v-else>
            <div class="cheque-report-cards__toolbar">
              <input
                v-model="cardSearch"
                type="search"
                class="form-control cheque-report-cards__search"
                placeholder=" جستجو"
                aria-label="جستجو در چک‌ها"
              />
              <button type="button" class="btn btn-outline-success cheque-report-cards__excel" title="دانلود فایل اکسل" aria-label="دانلود فایل اکسل" @click="Download">
                <i class="fas fa-file-excel" aria-hidden="true"></i>
              </button>
            </div>
            <p v-if="filteredCardRows.length === 0" class="cheque-report-cards__empty">اطلاعاتی یافت نشد</p>
            <div v-else class="cheque-report-cards__list">
              <article v-for="(row, index) in pagedCardRows" :key="(row.ChkId || 'row') + '-' + index" class="cheque-report-card">
                <div class="cheque-report-card__header">
                  <strong class="cheque-report-card__name">{{ row.SahebCheck || ('چک ' + (row.SerialChk || '')) }}</strong>
                  <span v-if="row.Name" class="cheque-report-card__badge">{{ row.Name }}</span>
                </div>
                <div class="cheque-report-card__amount">
                  <span dir="ltr">{{ cardValue(row.MablaghChk) }}</span>
                  <small>مبلغ چک</small>
                </div>
                <div class="cheque-report-card__fields">
                  <div class="cheque-report-card__field">
                    <span>شماره چک</span>
                    <strong dir="ltr">{{ cardValue(row.SerialChk) }}</strong>
                  </div>
                  <div class="cheque-report-card__field">
                    <span>تاریخ چک</span>
                    <strong>{{ cardValue(row.TarixChk) }}</strong>
                  </div>
                  <div class="cheque-report-card__field">
                    <span>تاریخ دریافت</span>
                    <strong>{{ cardValue(row.TarixDaryaft) }}</strong>
                  </div>
                  <div class="cheque-report-card__field">
                    <span>شماره حساب چک</span>
                    <strong dir="ltr">{{ cardValue(row.ShHesabChk) }}</strong>
                  </div>
                  <div class="cheque-report-card__field">
                    <span>نام بانک</span>
                    <strong>{{ cardValue(row.BankName) }}</strong>
                  </div>
                  <div v-if="row.ShobeChk" class="cheque-report-card__field">
                    <span>شعبه</span>
                    <strong>{{ row.ShobeChk }}</strong>
                  </div>
                  <div v-if="row.VCode" class="cheque-report-card__field">
                    <span>حساب/تسهیلات</span>
                    <strong dir="ltr">{{ row.VCode }}</strong>
                  </div>
                </div>
              </article>
            </div>
            <div v-if="filteredCardRows.length > cardPerPage" class="cheque-report-cards__pager">
              <button type="button" class="cheque-report-cards__pager-btn" :disabled="cardPage <= 1" @click="cardPage = cardPage - 1">قبلی</button>
              <span class="cheque-report-cards__pager-info">صفحه {{ cardPage }} از {{ cardPageCount }}</span>
              <button type="button" class="cheque-report-cards__pager-btn" :disabled="cardPage >= cardPageCount" @click="cardPage = cardPage + 1">بعدی</button>
            </div>
          </template>
        </div>

        <div class="cheque-report-table-view">
          <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config" :classes="classes" :actions="actions" @on-download="Download">
            <template slot="sort-asc-icon">
              <i class="fa fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
              <i class="fa fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
              <i class="fa fa-sort"></i>
            </template>
            <template slot="empty-results">
              <p class="text-right">اطلاعاتی یافت نشد</p>
            </template>
          </vue-bootstrap4-table>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import Panel from "../Tools/NetPa/Panel.vue";
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  data() {
    return {
      DataAxios_cmbTaahodat: { ArryfildValue: "", Method: "Post", Action: "ListTaahodat", Token: this.$session.get("TokenNetPa"), },
      DataAxios_SahebHesab: { ArryfildValue: "", Method: "Post", Action: "ListTaahodat/TaahodatSahebHesab", Token: this.$session.get("TokenNetPa"), },
      DataAxiosRow: { ArryfildValue: "", Method: "Post", Action: "ChkSareHesabNew", Token: this.$session.get("TokenNetPa"), },
      exceltable: [],
      TarikhTa: '',
      TarikhAz: '',
      ListModel: null,
      ListModelcmb: null,
      ListModelSahebHesab: null,
      Resultcmb: null,
      ResultcmbGrp8: null,
      IsLoad: false,
      ShomareChek: '',
      rows: [],
      cardSearch: '',
      cardPage: 1,
      cardPerPage: 10,
      columns: [{
        label: "ChkId",
        name: "ChkId",
        visibility: false,
      },
      {
        label: "شماره چک",
        name: "SerialChk",
      },
      {
        label: "تاریخ دریافت",
        name: "TarixDaryaft",
      },
      {
        label: "تاریخ چک",
        name: "TarixChk",
      },
      {
        label: "مبلغ چک",
        name: "MablaghChk",
      },
      {
        label: "شماره حساب چک",
        name: "ShHesabChk",
      },
      {
        label: "نام بانک",
        name: "BankName",
      },
      {
        label: "شعبه",
        name: "ShobeChk",
      },
      {
        label: "وضعیت چک",
        name: "Name",
      },
      {
        label: "صاحب چک",
        name: "SahebCheck",
      },
      {
        label: "حساب/تسهیلات",
        name: "VCode",
      },
      ],
      actions: [{
        btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
        event_name: "on-download",
        class: "btn  mx-2 btn-outline-success rounded btnEXL ",
        event_payload: { msg: "my custom msg", },
      }],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      loadingRender: false,
    }
  },
  computed: {
    filteredCardRows() {
      const q = (this.cardSearch || "").trim().toLowerCase();
      if (!q) return this.rows;
      return this.rows.filter((row) => {
        const hay = [row.SerialChk, row.TarixDaryaft, row.TarixChk, row.MablaghChk, row.ShHesabChk, row.BankName, row.ShobeChk, row.Name, row.SahebCheck, row.VCode]
          .filter((v) => v != null && v !== "")
          .join(" ")
          .toLowerCase();
        return hay.includes(q);
      });
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage;
      return this.filteredCardRows.slice(start, start + this.cardPerPage);
    },
    cardPageCount() {
      return Math.max(1, Math.ceil(this.filteredCardRows.length / this.cardPerPage));
    },
  },
  watch: {
    rows() {
      this.cardPage = 1;
    },
    cardSearch() {
      this.cardPage = 1;
    },
  },
  mounted() {
    this.loadingRender = true;
    this.ListModel = []
    const formData = new FormData();
    formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
    formData.append("wwwtblSarfaslTypeId", 1);
    this.DataAxios_cmbTaahodat.ArryfildValue = formData;
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          this.ListModel.push(element);
        }

        this.GetTaahodat()
      })
  },

  components: {
    VueBootstrap4Table,
    Panel,
    NetPaCard,
    loading
  },
  methods: {
    cardValue(val) {
      if (val == null || val === "") return "—";
      return val;
    },
    handleExcelSuccess() {},
    handleExcelError() {},

    GetTaahodat() {
      this.ResultcmbGrp8 = "-1"
      this.loadingRender = true;
      let info;
      const formData = new FormData();
      formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formData.append("wwwtblSarfaslTypeId", 2);
      this.DataAxios_cmbTaahodat.ArryfildValue = formData;
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true;
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            this.ListModel.push(element);
          }
          this.Resultcmb = this.ListModel[0].id
        })
        .finally(() => {
          const formData = new FormData();
          formData.append("wwwtblAzaId", this.$session.get("UserInfoNetPa").wwwtblAzaId);
          formData.append("wwwtblSarfaslTypeId", 2);
          this.DataAxios_SahebHesab.ArryfildValue = formData;
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true;
              this.ListModelSahebHesab = data;
              for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
                info = this.ListModelSahebHesab[index];
                this.ListModel.push(info);
              }
            }
          });
        }).finally(() => {
          this.loadingRender = false;
          var dataAxsiosCmb = { ArryfildValue: "", Method: "post", Action: "VaziatCombo", Token: this.$session.get("TokenNetPa") }
          const formData = new FormData();
          formData.append('num', 8);
          dataAxsiosCmb.ArryfildValue = formData;
          this.$PostFormData(dataAxsiosCmb).then((datacmb) => {
            this.loadingRender = false;
            if (datacmb.length > 0) {
              this.ListModelcmb = datacmb;
            }
          })
        });
    },

    GetCheque() {
      this.loadingRender = true;
      let info;
      let list = [];
      const formData = new FormData();
      formData.append('wwwtblAzaId', this.$session.get("UserInfoNetPa").wwwtblAzaId);
      formData.append('wwwtblShobeId', this.$session.get("UserInfoNetPa").wwwtblShobeId);
      formData.append('AzTarix', this.TarikhAz == null ? "" : this.TarikhAz);
      formData.append('TaTarix', this.TarikhTa == null ? "" : this.TarikhTa);
      formData.append('tblComboIdVaziyatChk8', this.ResultcmbGrp8 == "-1" ? null : this.ResultcmbGrp8);
      formData.append('wwwtblTaahodatId', this.Resultcmb);
      formData.append('SerialChk', this.ShomareChek);
      this.DataAxiosRow.ArryfildValue = formData;
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        if (typeof (data) == "string") {
          data = JSON.parse(data)
        }
        if (data.length > 0) {
          if (data[0].ChkId > 0) {
            if (data.length > 10) {
              this.config.pagination = true;
            } else {
              this.config.pagination = false;
            }
            for (let index = 0; index < data.length; index++) {
              info = data[index];
              list.push(info);
            }

            this.loadingRender = false;
            this.rows = this.$FormatMablaghGrid(list);
            this.exelReport(this.rows);
            this.$store.state.renderComponent = false;
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
          }
          else {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "عدم وجود اطلاعات",
              "اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
              "info",
              2000
            );
            this.config.pagination = false;
            this.rows = [];
          }
        } else {
          this.loadingRender = false;
          this.$mySweetDefaultTost(
            "عدم وجود اطلاعات",
            "اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
            "info",
            2000
          );
          this.config.pagination = false;
          this.rows = [];
        }
      });
    },
    Download() {
      document.getElementById("DownloadExcel").click();
    },
    exelReport(rows) {
      this.exceltable = [];
      rows.forEach((element) => {
        var excelrow = {
          "شماره چک": element.SerialChk,
          "تاریخ دریافت": element.TarixDaryaft,
          "مبلغ چک": element.MablaghChk,
          "شماره حساب چک": element.ShHesabChk,
          "نام بانک": element.BankName,
          "شعبه": element.ShobeChk,
          "وضعیت چک": element.Name,
          "صاحب چک": element.SahebCheck,
          "حساب/تسهیلات": element.VCode
        };

        this.exceltable.push(excelrow);
      });
    },
  }
}
</script>
<style scoped>
.cheque-report-filters {
  width: 100%;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

.cheque-report-hint {
  margin: 0 0 0.85rem;
  color: #6b7b8e;
  font-size: 13px;
  line-height: 1.7;
}

.cheque-report-hint strong {
  color: #29345f;
  font-weight: 800;
}

.cheque-report-filters__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
}

.cheque-report-field {
  display: flex;
  flex: 0 1 16rem;
  flex-direction: column;
  max-width: 16rem;
  min-width: 10rem;
  text-align: right;
}

.cheque-report-field--action {
  flex: 0 0 auto;
  max-width: none;
  min-width: 0;
}

.cheque-report-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
}

.cheque-report-label--spacer {
  visibility: hidden;
  user-select: none;
}

.cheque-report-field .form-control {
  width: 100%;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.cheque-report-field .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.cheque-report-field--date >>> .vpd-main {
  display: block;
  width: 100%;
}

.cheque-report-field--date >>> .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.cheque-report-field--date >>> .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.cheque-report-field--date >>> .vpd-input-group input,
.cheque-report-field--date >>> .vpd-input-group input.form-control {
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
}

.cheque-report-field--date >>> .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

.cheque-report-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.75rem;
  min-height: 40px;
  height: 40px;
  margin: 0;
  padding: 0 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .cheque-report-field,
  .cheque-report-field--action {
    flex: 1 1 100%;
    max-width: none;
    min-width: 0;
  }

  .cheque-report-search-btn {
    width: 100%;
  }
}

.cheque-report-cards {
  display: none;
}

.cheque-report-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

.cheque-report-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.cheque-report-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.cheque-report-cards__excel {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 12px;
}

.cheque-report-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.cheque-report-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cheque-report-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.cheque-report-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.55rem;
}

.cheque-report-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.cheque-report-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  color: #287db4;
  background: #edf5fb;
  font-size: 12px;
  font-weight: 800;
}

.cheque-report-card__amount {
  margin: 0 0 0.75rem;
  color: #29345f;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.cheque-report-card__amount small {
  margin-right: 0.3rem;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.cheque-report-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.cheque-report-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.cheque-report-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.cheque-report-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.cheque-report-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.cheque-report-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.cheque-report-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.cheque-report-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .cheque-report-cards {
    display: block;
  }

  .cheque-report-table-view {
    display: none;
  }
}
</style>
